@import '../../utils/chrome-layout.css';

:host {
  display: block;
  min-width: 0;
  box-sizing: border-box;
  background: var(--color-background-primary);
  color: var(--color-foreground-primary);
}

:host([tone='brand']) {
  background: var(--color-background-bold-brand);
  color: var(--color-foreground-on-bold);
}

.mobile-header {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 0;
  box-sizing: border-box;
  background: inherit;
  color: inherit;
}

.mobile-header__primary {
  grid-template-columns: minmax(var(--dimension-size-400), 1fr) minmax(0, auto) minmax(var(--dimension-size-400), 1fr);
  width: 100%;
  height: calc(var(--dimension-size-500) + var(--dimension-space-200));
  min-width: 0;
  background: inherit;
  color: inherit;
}

.mobile-header__primary--segmented {
  grid-template-columns:
    minmax(var(--dimension-size-500), 1fr)
    minmax(0, 4fr)
    minmax(var(--dimension-size-500), 1fr);
}

.mobile-header__primary--segmented .mobile-header__center,
.mobile-header__primary--segmented ds-tab-group {
  width: 100%;
}

:host(:not([tone='brand'])) .mobile-header::after {
  content: '';
  position: absolute;
  inset-inline: 0;
  inset-block-end: 0;
  height: var(--dimension-stroke-width-012);
  background: var(--color-border-tertiary);
  pointer-events: none;
}

.mobile-header__subsections {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 0;
  height: var(--dimension-size-600);
  padding: var(--dimension-space-100) var(--dimension-space-200);
  box-sizing: border-box;
}

.mobile-header__subsections ds-mobile-section-switcher {
  min-width: 0;
  max-width: 100%;
}

.mobile-header__lane {
  display: flex;
  align-items: center;
  gap: var(--dimension-space-050);
  min-width: 0;
}

.mobile-header__lane--leading {
  justify-content: flex-start;
}

.mobile-header__lane--trailing {
  justify-content: flex-end;
}

.mobile-header__center {
  position: relative;
  min-width: 0;
  max-width: 100%;
  justify-self: center;
}

.mobile-header__heading {
  display: block;
  min-width: 0;
  max-width: 100%;
  text-align: center;
}

.mobile-header__semantic-heading {
  position: absolute;
  width: var(--dimension-stroke-width-012);
  height: var(--dimension-stroke-width-012);
  padding: 0;
  margin: calc(var(--dimension-stroke-width-012) * -1);
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

::slotted([slot='leading']),
::slotted([slot='trailing']) {
  flex: 0 0 auto;
}
